import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AppRoutes from "@/routes";
import ScrollToTop from "@/components/shared/ScrollToTop";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[var(--color-bg-primary)] text-[var(--color-text-primary)]">
      <ScrollToTop />
      <AppRoutes />
    </div>
  );
}

export default App;
